import Vue from 'vue'

export default function request(method, url, sendData, deal) {
    Vue.axios({
            method: method,
            url: this.$baseurl + url,
            data: JSON.stringify(sendData),
            headers: {
                'Content-Type': 'application/json'
            },
            responseType: "blob", //服务器返回的数据类型
        })
        .then(
            res => {
                console.log("请求返回的数据:", res);
                switch (res.status) {
                    case 200:
                        deal(res.data)
                        break;

                    case 500:
                        this.$message.error(res.data.message);
                        break;
                    case 401:
                        window.sessionStorage.removeItem("token");
                        this.$router.push("/");
                        this.$message.error(res.data.msg);
                        break;

                    default:
                        this.$message.error(res.data.message);
                        break;
                }
            }
        ).catch(() => {
            this.$message.error('地址异常');
        })

}